/** Montage du chat Laika : auth pro + zone privée /app (jamais landing/public). */
export function shouldMountLaikaChat(params: {
  laikaUiEnabled: boolean;
  isAuthenticated: boolean;
  pathname: string;
}): boolean {
  return (
    params.laikaUiEnabled &&
    params.isAuthenticated &&
    params.pathname.startsWith('/app')
  );
}

/** Visibilité du FAB Laika (chat fermé, auth, hors iOS free, hors dock CGV). */
export function shouldShowLaikaFab(params: {
  isAuthenticated: boolean;
  isChatOpen: boolean;
  isIOSFreeUser: boolean;
  isDocked?: boolean;
}): boolean {
  return (
    params.isAuthenticated &&
    !params.isChatOpen &&
    !params.isIOSFreeUser &&
    !params.isDocked
  );
}
